import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import FeatureMaterialTable from './FeatureMaterialTable';
import FeatureProductTable from './FeatureProductTable';

interface FeatureTableProps {
  currentSelectNode: any;
  pageType: string;
}

const FeatureTable: ForwardRefExoticComponent<PropsWithoutRef<FeatureTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
  },
  ref,
) => {
  return (
    <>
      {currentSelectNode?.isMaterial ? (
        <FeatureMaterialTable
          currentSelectNode={currentSelectNode}
          pageType={pageType}
        />
      ) : (
        <FeatureProductTable
          currentSelectNode={currentSelectNode}
          pageType={pageType}
        />
      )}
    </>
  );
});

export default FeatureTable;
